import React from 'react';
import {useFaqListContext} from './faq-list-context';
import {useComponent} from '../component-library';
import styled from 'styled-components';
import {useFeatureAppId} from '../utils/use-feature-app-id';
import {FaqItem} from '../types';

export interface QuestionsAccordionProps {
  items: FaqItem[];
}

export function QuestionsAccordion(
  props: QuestionsAccordionProps
): JSX.Element {
  const {refHandle} = useFaqListContext();
  const {items} = props;
  const baseId = useFeatureAppId();
  // Assumption: There is never more than one FAQ list per feature app!
  const accordionId = `${baseId}_faq-list`;
  const FaqList = useComponent('FaqList');

  return (
    <WidthWrapper>
      <LayoutWrapper>
        <FaqList refHandle={refHandle} id={accordionId} items={items} />
      </LayoutWrapper>
    </WidthWrapper>
  );
}

const WidthWrapper = styled.div`
  flex-shrink: 0;
  width: ${(props) =>
    props.theme.brand.spacing.customOneColumnBreakpoint
      ? '100%'
      : props.theme.internal.size.grid017};
  max-width: ${(props) =>
    props.theme.brand.spacing.customOneColumnBreakpoint
      ? props.theme.internal.size.grid017
      : '100%'};
  overflow: hidden;
`;

const LayoutWrapper = styled.div`
  padding: ${(props) => props.theme.internal.size.grid001};
`;
